import React from 'react'

function Loader() {
  return (
     <div className="loader text-white">
             <div className="d-flex flex-column flex-root">
              <div className="page d-flex flex-row flex-column-fluid">
                <div className="page-content ps-0 ms-0 d-flex flex-column flex-row-fluid">
                  <div
                    className="content flex-column p-4 pb-0 d-flex justify-content-center align-items-center flex-column-fluid position-relative"> 
                    <div className="w-100 h-100 position-relative d-flex align-items-center justify-content-center">
                  <div style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "rgba(0,0,0,0.3)"
                  }}>
                <div className="spinner-border text-warning" style={{width:"4rem",height:"4rem" }} >
                  
                  </div>
                </div>
         
                    <div style={{marginTop: "5rem"}}>
                        
                    </div>
                  </div>
                 </div>
               </div>
              </div>
            </div>
          </div> 
  )
}

export default Loader